import type { JSX } from '@builder.io/qwik';
import { Slot, component$, useContextProvider } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import type { GalleryBlockInterface } from '~/types/AppData/PageBuilder/GalleryBlockInterface';
import AnalyticsContainer from '~/components/Shared/Analytics/AnalyticsContainer';
import type { GalleryColumnBlockInterface } from '~/types/AppData/PageBuilder/GalleryColumnBlockInterface';
import { getOneIndexing } from '~/utilities/getOneIndexing';
import { CardContext } from '~/contexts/CardContext';

const cssClasses = cva('flex flex-col md:flex-row gap-x-4 relative', {
  variants: {
    branding: {
      '': 'gap-y-5',
      onSI: 'md:gap-y-2.5 [&>.gallery-column]:border-b [&>.gallery-column]:border-borderGrey [&>.gallery-column:last-of-type]:border-none [&>.gallery-column]:md:border-none [&>.gallery-column]:md:pb-2.5 [&>.gallery-column:last-of-type]:pb-0 [&>.gallery-column_.card]:py-2.5 [&>.gallery-column_.card]:border-grey',
    },
  },
  defaultVariants: {
    branding: '',
  },
});

export default component$<
  GalleryBlockInterface['props'] & {
    items: GalleryColumnBlockInterface[];
    index: number;
  }
>(({ branding, columns, items, index }): JSX.Element => {
  const numCards = items
    .filter((each) => each.type === 'GalleryColumn')
    .reduce(
      (acc: number, cur: GalleryColumnBlockInterface) =>
        acc +
        (cur.children?.filter((each) => each.type === 'Card').length ?? 0),
      0
    );

  const componentName = `Gallery-${getOneIndexing(index)}`;
  // @ts-ignore missing required CardPropsInterface properties
  useContextProvider(CardContext, {
    columns,
  });

  return (
    <div class={cssClasses({ branding })}>
      <AnalyticsContainer
        component_name={componentName}
        amount_of_articles={numCards}
        component_type='Gallery'
        component_placement={getOneIndexing(index)}
      >
        <Slot />
      </AnalyticsContainer>
    </div>
  );
});
